angular.module('qkr').controller('LoyaltyCardController', ($scope, gettextCatalog, $uibModal, loyaltyCardService,
                                                           $location, appConfig, FormHelper, messageService, utils) => {
    $scope.loading = true;
    $scope.loyaltyCardList = [];
    $scope.selectedSort = '';
    const formHelper = new FormHelper($scope);

    $scope.initLoyaltyCard = function() {
        loyaltyCardService.loadLoyaltyCardList().then((promise) => {
            $scope.loyaltyCardList = promise;

            angular.forEach($scope.loyaltyCardList, (loyaltyCard) => {
                const loyaltyCardDate = utils.serverDateStringtoDate(loyaltyCard.expiryDate);
            });
            $scope.loading = false;
        });
    };

    $scope.editLoyaltyCard = function(loyaltyCard) {
        $location.path('/merchant/loyaltyCardCreate/' + loyaltyCard.id);
    };

    $scope.createLoyaltyCard = function() {
        $location.path('/merchant/loyaltyCardCreate/');
    };

    $scope.activateLoyaltyCard = function(loyaltyCard) {
        const activateModalInstance = $uibModal.open({
            template: require('../../loyalty/templates/loyaltyCardActivate.modal.html'),
            controller: 'LoyaltyCardActivateModalController',
            windowClass: 'fade',
            backdrop: 'static',
            resolve: {
                loyaltyCard() {
                    return angular.copy(loyaltyCard);
                }
            }
        }, () => {
        });

        activateModalInstance.result.then((promise) => {
            if (promise !== 'cancel') {
                loyaltyCardCallback(promise, loyaltyCard, true);
            }
        });
    };

    $scope.deactivateLoyaltyCard = function(loyaltyCard) {
        const modalInstance = confirmStateModal((gettextCatalog.getString('Deactivate ')) + loyaltyCard.schemeName + (gettextCatalog.getString('?')), (gettextCatalog.getString('Deactivate')), (gettextCatalog.getString('Are you sure you want to deactivate this program?')));

        modalInstance.result.then((result) => {
            if (result === 'ok') {
                loyaltyCardService.deactivateLoyaltyCard(loyaltyCard.id).then((promise) => {
                    loyaltyCardCallback(promise, loyaltyCard, true);
                });
            }
        }, () => {
        });
    };

    $scope.deleteLoyaltyCard = function(loyaltyCard) {
        const modalInstance = confirmStateModal((gettextCatalog.getString('Delete ')) + loyaltyCard.schemeName + (gettextCatalog.getString('?')), (gettextCatalog.getString('Delete')), (gettextCatalog.getString('Are you sure you want to delete this program?')));

        modalInstance.result.then((result) => {
            if (result === 'ok') {
                loyaltyCardService.deleteLoyaltyCard(loyaltyCard.id).then((promise) => {
                    loyaltyCardCallback(promise, loyaltyCard, false);
                });
            }
        }, () => {
        });
    };

    $scope.changeSort = function(selectedSort) {
        if ($scope.selectedSort === selectedSort) {
            $scope.selectedSort = '-' + selectedSort;
        } else {
            $scope.selectedSort = selectedSort;
        }
    };

    var confirmStateModal = function(title, confirmButtonName, confimMsg) {
        return $uibModal.open({
            template: require('../../templates/common/modalDialog.html'),
            controller: 'commonModalDialogController',
            windowClass: 'fade',
            backdrop: 'static',
            resolve: {
                title() {
                    return title;
                },
                confirmButtonName() {
                    return confirmButtonName;
                },
                confirmMsg() {
                    return confimMsg;
                },
                multiMsgArray() {
                    return [];
                }
            }
        });
    };

    var loyaltyCardCallback = function(promise, loyaltyCard, isActivate) {
        const r = formHelper.handleResponse(promise);
        if (r.isSuccess()) {
                loyaltyCardService.emptyLoyaltyCardList();
                loyaltyCardService.loadLoyaltyCardList().then((loyaltyCardListPromise) => {
                    $scope.loyaltyCardList = loyaltyCardListPromise;
                    messageService.saveAlert(gettextCatalog.getString('Changes Saved'));
            });
        } else {
            messageService.error(gettextCatalog.getString('Could not update. Please try again.'));
        }
    };
});

angular.module('qkr').controller('LoyaltyCardCreateController', ($scope, gettextCatalog, loyaltyCardService,
                                                                 loyaltyCard, inventoryService, $uibModal, appConfig,
                                                                 FormHelper, utils, $location, messageService) => {
    $scope.loading = true;
    $scope.saving = false;
    $scope.isCreate = (loyaltyCard == null);
    const formHelper = new FormHelper($scope);

    $scope.numberOnly = /^[0-9]+$/;

    $scope.form = {};

    $scope.initLoyaltyCardCreate = function() {
        $scope.stampOptions = [];
        $scope.loading = true;

        loyaltyCardService.getPunchCardIconList().then((promise) => {
            createStampOptions(promise);
            if (loyaltyCard != null) {
                $scope.form = loyaltyCard;
                const serverDate = utils.serverDateStringtoDate(loyaltyCard.expiryDate);
                for (let i = 0; i < $scope.stampOptions.length; i++) {
                    if ($scope.stampOptions[i].key == $scope.form.lookAndFeel.stampLogoKey) {
                        $scope.form.lookAndFeel.stampLogoKey = $scope.stampOptions[i].key;
                        $scope.form.lookAndFeel.stampLogoUrl = $scope.stampOptions[i].url;
                    }
                }

                if (serverDate.getFullYear() < 2999) {
                    $scope.form.fixedExpiryDate = true;
                    $scope.form.expiryDate = new Date($scope.form.expiryDate);
                } else {
                    $scope.form.fixedExpiryDate = false;
                    $scope.form.expiryDate = new Date();
                    $scope.form.expiryDate.setDate($scope.form.expiryDate.getDate() + 1);
                }
            } else {
                $scope.form = {};
                $scope.form.schemeName = '';
                $scope.form.active = true;
                $scope.form.products = {};
                $scope.form.expiryDate = new Date();
                $scope.form.expiryDate.setDate($scope.form.expiryDate.getDate() + 1);
                $scope.form.fixedExpiryDate = false;
                $scope.form.products.qualifyingProductCount = 9;
                $scope.form.products.qualifyingInventoryItemIds = [];
                $scope.form.products.redeemableInventoryItemIds = [];
                $scope.form.lookAndFeel = {};
                $scope.form.lookAndFeel.backgroundColour = '#f5761a';
                $scope.form.lookAndFeel.stampCircleColour = '#ef3821';
                $scope.form.lookAndFeel.label = '';
                $scope.form.lookAndFeel.stampLogoKey = $scope.stampOptions[0].key;
            }

            $scope.loading = false;
        });
    };

    $scope.create = function(isActive) {
        if (!$scope.form.fixedExpiryDate) {
            $scope.form.expiryDate = new Date(3000, 0, 0, 23, 59, 59, 0);
        }

        if (!validate()) {
            return;
        }

        $scope.form.lookAndFeel.label = $scope.form.schemeName;
        $scope.form.active = isActive;
        $scope.form.expiryDate.setSeconds(59);
        $scope.form.expiryDate.setMinutes(59);
        $scope.form.expiryDate.setHours(23);
        $scope.form.expiryDate = $scope.form.expiryDate.getTime();
        $scope.saving = true;

        loyaltyCardService.createPunchCardRewardScheme($scope.form).then((promise) => {
            $scope.punchCardCallback(promise);
        });
    };

    $scope.update = function() {
        if (!$scope.form.fixedExpiryDate) {
            $scope.form.expiryDate = new Date(3000, 0, 0, 23, 59, 59, 0);
        }

        if (!validate()) {
            return;
        }

        $scope.form = angular.copy($scope.form);
        $scope.form.id = {id: $scope.form.id};

        // Moving it to a second before midnight
        $scope.form.expiryDate.setSeconds(59);
        $scope.form.expiryDate.setMinutes(59);
        $scope.form.expiryDate.setHours(23);
        $scope.form.expiryDate = $scope.form.expiryDate.getTime();

        $scope.saving = true;
        loyaltyCardService.updatePunchCardRewardScheme($scope.form).then((promise) => {
            $scope.punchCardCallback(promise);
        });
    };

    $scope.punchCardCallback = function(response) {
        const r = formHelper.handleResponse(response);
        $scope.saving = false;

        if (r.isSuccess()) {
            loyaltyCardService.emptyLoyaltyCardList();
            loyaltyCardService.loadLoyaltyCardList().then((loyaltyCardListPromise) => {
                messageService.saveAlert(gettextCatalog.getString('Changes Saved'));
                returnToList();
            });
        } else {
            messageService.error(gettextCatalog.getString('Could not update. Please try again.'));
        }
    };

    $scope.numberCheck = function() {
        if (typeof ($scope.form.products.qualifyingProductCount) !== 'number') {
            $scope.form.products.qualifyingProductCount = 1;
        }
    };

    $scope.cancel = function() {
        returnToList();
    };

    var returnToList = function() {
        $location.path('/merchant/loyaltyCardList');
    };

    $scope.openProductSelector = function() {
        inventoryService.loadInventory().then((promise) => {
            const productList = promise;
            const preSelectedProducts = ($scope.form.products.qualifyingInventoryItemIds.length > 0) ? $scope.form.products.qualifyingInventoryItemIds : [];
            const lockedProducts = loyaltyCardService.getSelectedProductsList();

            openProductSelectorModal(productList, preSelectedProducts, lockedProducts);
        });
    };

    $scope.openPreview = function() {
        modalInstance = $uibModal.open({
            template: require('../../loyalty/templates/loyaltyPreview.modal.html'),
            controller: 'LoyaltyCardPreviewController',
            windowClass: 'modal-huge',
            backdrop: 'static',
            resolve: {
                form() {
                    return angular.copy($scope.form);
                }
            }
        });
    };

    var openProductSelectorModal = function(productList, preSelectedProducts, lockedProducts) {
        const modalInstance = $uibModal.open({
            template: require('../../loyalty/templates/loyaltyCardProductSelector.html'),
            controller: 'LoyaltyCardProductSelectorController',
            windowClass: 'modal-huge',
            backdrop: 'static',
            resolve: {
                preSelectedProducts() {
                    return angular.copy(preSelectedProducts);
                },
                productList() {
                    return angular.copy(productList);
                },
                lockedProducts() {
                    return angular.copy(lockedProducts);
                },
                readOnly() {
                    return !$scope.isCreate;
                }
            }

        });

        modalInstance.result.then((result) => {
            if (result != 'cancel') {
                $scope.form.products.qualifyingInventoryItemIds = [];
                $scope.form.products.redeemableInventoryItemIds = [];
                angular.forEach(result, (category) => {
                    angular.forEach(category.products, (product) => {
                        if (product.selected == 1) {
                            $scope.form.products.qualifyingInventoryItemIds.push({id: product.id});
                        }
                    });
                });
                $scope.form.products.redeemableInventoryItemIds = angular.copy($scope.form.products.qualifyingInventoryItemIds);
            }
        }, () => {
        });
    };

    var validate = function() {
        $scope.errors = {};
        const errors = {};
        let valid = true;

        if (utils.hasNoValue($scope.form.schemeName)) {
            errors.schemeName = gettextCatalog.getString('Please enter a name');
            valid = false;
        }

        if (utils.hasNoValue($scope.form.products.qualifyingProductCount) || ($scope.form.products.qualifyingProductCount < 1) || ($scope.form.products.qualifyingProductCount > 99)) {
            errors.qualifyingProductCount = gettextCatalog.getString('Please enter a value between 1 and 99');
            valid = false;
        }

        if (utils.hasNoValue($scope.form.products.redeemableInventoryItemIds)) {
            errors.qualifyingInventoryItemIds = gettextCatalog.getString('Please select at least one product');
            valid = false;
        }

        if (utils.hasNoValue($scope.form.lookAndFeel.backgroundColour) || utils.hasNoValue($scope.form.lookAndFeel.stampCircleColour)) {
            errors.backgroundColour = gettextCatalog.getString('Please enter both background colours');
            valid = false;
        }
        if (utils.hasNoValue($scope.form.lookAndFeel.stampCircleColour)) {
            errors.stampCircleColour = gettextCatalog.getString('Please enter a icon colour');
            valid = false;
        }

        if ($scope.form.fixedExpiryDate) {
            if (utils.hasNoValue($scope.form.expiryDate)) {
                errors.expiryDate = gettextCatalog.getString('Please enter an expiry date');
                valid = false;
            } else if ($scope.form.expiryDate <= new Date()) {
                errors.expiryDate = gettextCatalog.getString('Expiry dates must be after today');
                valid = false;
            }
        }

        $scope.errors = errors;
        return valid;
    };

    var createStampOptions = function(stampMap) {
        $scope.stampOptions = [];

        angular.forEach(stampMap, (stamp) => {
            $scope.stampOptions.push({displayName: stamp.key, key: stamp.key, url: stamp.url});
        });
    };

    $scope.dateOptions = {
        startingDay: 1, // $rootScope.merchantInfo.contactDetails.country.weekStartingDay,
        showWeeks: false
    };
});



// WEBPACK FOOTER //
// ./src/loyalty/controllers/loyaltyCard.controller.js